import { duplicateDecision } from "api";
import { Error } from "utils/Response";
import { GetDecision, SetDecision } from "../GetDecision/action";
import {GetMinimalDecisionInfo, SetMinimalDecisionInfo} from "../GetMinimalDecisionInfo/action";
import { ActionTypes } from "./types";

export const DuplicateDecision = (decisionId, callback, isCard=false) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await duplicateDecision(decisionId);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
      if(isCard){
         dispatch(SetMinimalDecisionInfo(data));
      }else{
        dispatch(SetDecision(data));
      }
   
    }

    if (callback) {
      callback(data);
    }
  } catch (error) {
    if(isCard){
      dispatch(GetMinimalDecisionInfo());
    }else{
      dispatch(GetDecision(false));
    }
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
